import { Injectable } from "@angular/core";

@Injectable()
export class LocalResourcesManagerService {
  constructor() {}

  public setCurrentAssetsParentPath(assetsPath: string) {
    localStorage.setItem("currentAssetsParentPath", assetsPath);
  }
  public getCurrentAssetsParentPath(): string {
    return localStorage.getItem("currentAssetsParentPath");
  }
}
